<template>
  <div class="we-plan-card shadow-md shadow-contrast-brand-400/10 py-8 px-6 bg-white rounded-3xl w-[256px] relative border border-gray-100">
    
    <div class="font-bold text-primary-brand-200 text-3xl leading-tight relative z-10">
      {{ speed }} Mega
    </div>
    
    <div class="text-primary-brand-200 font-semibold text-base mb-2 relative z-10 whitespace-pre-wrap leading-tight">
      {{ plan.title }}
    </div>

    <div class="mb-6 relative z-10">

      <div v-if="type != 'plan'" class="flex items-center justify-center gap-x-1.5">

        <div v-for="(feature, index) in plan.features" :key="index">
            <div v-if="feature.enable" class="w-10 aspect-square flex items-center justify-center rounded-full border border-secondary-brand-300">
              <img :src="feature.icon" class="w-full h-full object-contain p-2">
            </div>
        </div>

      </div>

    </div>
    
    <div class="flex flex-col relative z-10" :class="priceBoxSize">

        <div class="text-[#888888] mb-1">Por apenas</div>
      
        <div class="flex items-end text-primary-brand-200 font-bold text-[40px] leading-none tracking-tighter">
            R$ {{ plan.price }},{{ plan.price_decimal }} <span class="ml-1 mb-1 text-base text-[#888888] leading-none tracking-normal font-normal">/mês</span>
        </div>
    </div>
        
    <div class="mt-10 relative z-10">
      <we-button type="plans" label="Assinar agora" labelClasses="font-semibold" medium no-border no-icon :action="() => updateSelectedPlan(plan)"/>
    </div>

    <div class="flex px-6 mt-2 relative z-10">

      <div v-if="type != 'plan'" class="flex whitespace-normal text-center leading-1 text-xs text-gray-400">
        {{ plan.note }}
      </div>
    </div>

    <div class="absolute right-0 top-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="174" height="248" viewBox="0 0 174 248" fill="none">
          <g clip-path="url(#clip0_3724_6298)">
          <path d="M157.829 125.379C154.206 128.704 151.656 133.035 150.502 137.825C149.348 142.614 149.641 147.647 151.345 152.286C153.048 156.925 156.086 160.963 160.073 163.888C164.061 166.814 168.818 168.496 173.745 168.721C178.672 168.946 183.547 167.706 187.753 165.155C191.959 162.605 195.307 158.859 197.374 154.393C199.441 149.926 200.135 144.938 199.367 140.061C198.598 135.183 196.403 130.635 193.058 126.991C188.573 122.104 182.342 119.189 175.735 118.887C169.128 118.584 162.687 120.919 157.829 125.379ZM180.377 149.946C179.17 151.054 177.658 151.777 176.035 152.024C174.411 152.271 172.748 152.03 171.256 151.332C169.764 150.634 168.51 149.51 167.652 148.102C166.794 146.695 166.371 145.066 166.437 143.424C166.502 141.781 167.053 140.198 168.02 138.873C168.987 137.549 170.327 136.544 171.869 135.985C173.411 135.426 175.087 135.338 176.685 135.732C178.283 136.126 179.731 136.985 180.846 138.2C182.341 139.828 183.132 141.981 183.044 144.184C182.956 146.387 181.997 148.459 180.377 149.946ZM135.281 100.812C123.988 111.248 117.282 125.737 116.612 141.143C116.531 143.338 117.321 145.481 118.81 147.103C120.299 148.726 122.367 149.696 124.56 149.803C126.754 149.897 128.891 149.119 130.504 147.638C132.117 146.158 133.075 144.095 133.17 141.901C133.381 136.438 134.667 131.077 136.955 126.125C139.244 121.172 142.489 116.726 146.504 113.04C150.52 109.354 155.228 106.502 160.358 104.645C165.488 102.789 170.94 101.966 176.4 102.223C178.59 102.345 180.734 101.597 182.366 100.142C183.67 99.0769 184.617 97.6372 185.081 96.0149C185.544 94.3927 185.501 92.6649 184.958 91.0617C184.415 89.4585 183.398 88.056 182.042 87.0411C180.686 86.0261 179.055 85.4469 177.367 85.3806C169.667 85.0557 161.987 86.2512 154.765 88.8988C147.544 91.5465 140.923 95.5944 135.281 100.812ZM112.732 76.2445C94.9706 92.6343 84.4237 115.406 83.3786 139.622C83.3349 140.718 83.5073 141.812 83.8859 142.843C84.2645 143.874 84.8419 144.821 85.5852 145.631C87.0864 147.267 89.172 148.243 91.3833 148.344C93.5946 148.445 95.7503 147.663 97.3764 146.171C99.0025 144.679 99.9656 142.597 100.054 140.386C100.857 120.577 109.488 101.943 124.051 88.5766C138.614 75.2103 157.918 68.2048 177.723 69.0988C178.816 69.1444 179.906 68.9737 180.93 68.5965C181.955 68.2193 182.894 67.6431 183.693 66.9009C184.501 66.168 185.155 65.2819 185.619 64.2934C186.082 63.305 186.345 62.2336 186.393 61.1407C186.442 60.0445 186.272 58.9482 185.896 57.9153C185.519 56.8823 184.941 55.9331 184.197 55.1223C183.453 54.3115 182.557 53.6552 181.56 53.1913C180.563 52.7274 179.485 52.4651 178.389 52.4194C154.172 51.3893 130.581 59.9498 112.732 76.2445ZM179.716 19.178C163.353 18.4239 147.02 20.9022 131.651 26.4714C116.282 32.0407 102.178 40.5916 90.1456 51.6357C78.1128 62.6798 68.3868 76.0005 61.5235 90.8366C54.6601 105.673 50.7938 121.734 50.1455 138.101C50.0572 140.313 50.851 142.475 52.3521 144.11C53.8533 145.746 55.9389 146.722 58.1502 146.823C60.3615 146.924 62.5173 146.142 64.1433 144.65C65.7694 143.158 66.7325 141.077 66.8208 138.865C67.9712 110.238 80.4397 83.3063 101.485 63.9903C122.53 44.6742 150.43 34.555 179.05 35.8574C180.146 35.9121 181.241 35.7492 182.271 35.3781C183.301 35.0069 184.247 34.4349 185.053 33.6951C185.859 32.9553 186.51 32.0622 186.967 31.0675C187.425 30.0727 187.681 28.996 187.721 27.8993C187.769 26.8031 187.6 25.7069 187.223 24.6739C186.846 23.641 186.269 22.6917 185.524 21.8809C184.78 21.0701 183.884 20.4139 182.887 19.95C181.89 19.4861 180.812 19.2237 179.716 19.178Z" fill="#EFFFFD"/>
          </g>
          <defs>
          <clipPath id="clip0_3724_6298">
          <rect width="198.914" height="200.077" fill="white" transform="translate(0 100.504) rotate(-42.5466)"/>
          </clipPath>
          </defs>
        </svg>
    </div>

  </div>
</template>

<script setup>

  import { computed } from 'vue'
  import WeButton from './WeButton.vue'

  const emit = defineEmits('selectedPlan')

  const props = defineProps({
    plan: {
      type: Object,
      default: () => {}
    }
  })

  const type = computed(() => props.plan.type);

  const updateSelectedPlan = (plan) => {
      emit('selectedPlan', plan);
  };

  const priceBoxSize = computed(() => {
    const priceString = props.plan.price.value + ''
    return priceString.length > 2 ? 'max-w-[172px]' : 'max-w-[142px]'
  })

  const speed =  computed(() => {
      if (props.plan?.type != 'combo') {
          return props.plan?.details?.substring(0,3);
      } else {
          return props.plan?.speed?.substring(0,3);
      }
  })

</script>

